import AccountDefault from "../components/Account/Default";
import Profile from "../components/Account/Profile";
import Security from "../components/Account/Security";

const routes = [
  {
    path: "/account",
    redirect: "/account/profile",
    component: AccountDefault,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "profile",
        name: "accountProfile",
        component: Profile,
        meta: {
          requiresAuth: true,
          description: "Your profile",
        },
      },
      {
        path: "security",
        name: "accountSecurity",
        component: Security,
        meta: {
          requiresAuth: true,
          description: "Security settings",
        },
      },
    ],
  },
];

export default routes;
